<template>
  <div class="container clear">
  	<div class="left-body-area">
  		<div class="left-item">
  			<div class="left-item-body" @click="changeBox('ST')" :class="{active: type == 'ST'}">
  				<span></span>
  				<span></span>
  				<span></span>
  				<span></span>
  				<p>死淘(头)</p>
  				<div class="item-body-left">
  					<p>死亡值</p>
  					<div v-html="data1.death"></div>
  				</div>
  				<div class="item-body-right">
  					<p>淘汰值</p>
  					<div>{{data1.eliminate}}</div> 
  				</div>
  			</div>
  		</div>
  		<div class="left-item">
  			<div class="left-item-body" @click="changeBox('PZ')" :class="{active: type == 'PZ'}">
  				<span></span>
  				<span></span>
  				<span></span>
  				<span></span>
  				<p>配种(头)</p>
  				<div class="item-body-left">
  					<p>目标值</p>
  					<div v-html="data1.jhpzts">20</div>
  				</div>
  				<div class="item-body-right">
  					<p>实际值</p>
  					<div :class="['right-text',{down: data1.sjpzts < data1.jhpzts}]">{{data1.sjpzts}}<span>⬇</span></div> 
  				</div>
  			</div>
  		</div>
  		<div class="left-item">
  			<div class="left-item-body" @click="changeBox('FM')" :class="{active: type == 'FM'}">
  				<span></span>
  				<span></span>
  				<span></span>
  				<span></span>
  				<p>分娩(头)</p>
  				<div class="item-body-left">
  					<p>目标值</p>
  					<div v-html="data1.jhfmhzs"></div>
  				</div>
  				<div class="item-body-right">
  					<p>实际值</p>
  					<div :class="['right-text',{down: data1.sjfmhzs < data1.jhfmhzs}]">{{data1.sjfmhzs}}<span>⬇</span></div> 
  				</div>
  			</div>
  		</div>
  		<div class="left-item">
  			<div class="left-item-body" @click="changeBox('DN')" :class="{active: type == 'DN'}">
  				<span></span>
  				<span></span>
  				<span></span>
  				<span></span>
  				<p>断奶(头)</p>
  				<div class="item-body-left">
  					<p>目标值</p>
  					<div v-html="data1.jhdls">20</div>
  				</div>
  				<div class="item-body-right">
  					<p>实际值</p>
  					<div :class="['right-text',{down: data1.sjdls < data1.jhdls}]">{{data1.sjdls}}<span>⬇</span></div> 
  				</div>
  			</div>
  		</div>
  		<div class="left-item">
  			<div class="left-item-body" @click="changeBox('CL')" :class="{active: type == 'CL'}">
  				<span></span>
  				<span></span>
  				<span></span>
  				<span></span>
  				<p>出栏(头)</p>
  				<div class="item-body-left">
  					<p>目标值</p>
  					<div v-html="data1.jhcls">20</div>
  				</div>
  				<div class="item-body-right"> 
  					<p>实际值</p>
  					<div :class="['right-text',{down: data1.sjcls < data1.jhcls}]">{{data1.sjcls}}<span>⬇</span></div> 
  				</div>
  			</div>
  		</div>
  	</div>
  	
  	<div class="center-body-area st clear" v-if="type == 'ST'">
  		<div class="top-area map-level2">
  			<div id="st1" class="item-map"></div>
  			<div id="st2" class="item-map"></div>
  			<div id="st3" class="item-map"></div>
  		</div>
  		<div class="btn-box clear">
  			<span :key="item" v-for="item in pigFarmList" v-html="item.simpleName" :class="{active: pigFarm.id == item.id}" @click="getOtherFarm(item)"></span>
  		</div>
  		<div class="bottom-area map-level2 map-width50"> 
  			<div id="st4" class="item-map"></div>
  			<div id="st5" class="item-map"></div>
  		</div>
  	</div>
  	<div class="center-body-area pz clear" v-if="type == 'PZ'">
  		<div class="left-map-area clear">
  			<div class="map-level2" id="pz1">
  				
  			</div>
  			<div class="btn-box clear">
	  			<span :key="item" v-for="item in pigFarmList" v-html="item.simpleName" :class="{active: pigFarm.id == item.id}" @click="getOtherFarm(item)"></span>
	  		</div>
  			<div class="map-level2" id="pz2">
  				
  			</div>
  		</div>
  		<div class="right-map-area">
  			<div class="map-level2" id="pz3">
  				
  			</div>
  			<!--<div class="map-level3" id="pz4">
  				
  			</div>-->
  			
  			<div class="map-level2" id="pz5" style="margin-top: 50px;">
  				
  			</div>
  			
  		</div>
  	</div>
  	<div class="center-body-area fm clear" v-if="type == 'FM'">
  		<div class="left-map-area">
  			<p class="map-title">配种分娩率</p>
  			<div class="map-level4" id="fm1">
  				
  			</div>
  			<div class="map-level4" id="fm2">
  				
  			</div>
  			<p class="map-title">配种分娩率(胎龄分析)</p>
  			<div class="map-level4" id="fm3">
  				
  			</div>
  			<div class="map-level4" id="fm4">
  				
  			</div>
  		</div>
  		<div class="right-map-area">
  			<p class="map-title">产仔统计</p>
  			<div class="map-level4" id="fm5">
  				
  			</div>
  			<p class="map-title">哺乳猪成活率</p>
  			<!--<div class="map-level4" id="fm6">
  				
  			</div>-->
  			<div class="map-level4" id="fm8">
  				
  			</div>
  			<div class="map-level4" id="fm7">
  				
  			</div>
  			
  		</div>
  	</div>
  	<div class="center-body-area dn clear" v-if="type == 'DN'">
  		<div class="left-map-area">
  			<div class="map-level3" id="dn1"></div>
  			<div class="map-level3" id="dn2"></div>
  			<div class="map-level3" id="dn3"></div>
  		</div>
  		<div class="right-map-area">
  			<div class="map-level3" id="dn4"></div>
  			<div class="map-level3" id="dn5"></div>
  			<div class="map-level3" id="dn6"></div>
  		</div>
  	</div>
  	<div class="center-body-area cl clear" v-if="type == 'CL'"> 
  		<div>
  			<div class="map-level3" id="cl1"></div>
  			<div class="map-level3" id="cl2"></div>
  		</div>
  		
  		<!--<div class="map-level3" id="cl3"></div>-->
  	</div>
  </div>
</template>

<script>
import moment from "moment";
import echarts from "../../static/js/echart_init.js";
import { Button } from "element-ui";
import { mapMutations } from 'vuex';
import myVue from "../js/emit.js";
export default {
  data () {
    return {
      type: 'ST',
      data1: {},
      pigFarmList: [],
      pigFarm: {}
    }
  },
  components: {
		elButton: Button
	},
  filters: {
  	'moment': (val,format) => {
  		return val.format(format);
  	}
  },
  methods: {
  	...mapMutations([
  		'changeName'
  	]),
  	changeBox(type){
  		if(this.type == type) return;
  		this.type = type;
  		this.init();
  	},
  	init(){
  		if(this.type == 'ST'){
  			this.st();
  		}else if(this.type == 'PZ'){
  			this.pz();
  		}else if(this.type == 'FM'){
  			this.fm();
  		}else if(this.type == 'DN'){
  			this.dn();
  		}else if(this.type == 'CL'){
  			this.cl();
  		}
  	},
  	// 左侧
  	init1(){
  		this.$http({
        url: "",
      }).then(res => { 
       	if(res.data.statusCode == 200){
       		this.data1 = res.data.productionAnalysis.value;
       	}
      }).catch(err => { 
//      return this.$msg.error('修改失败!', 'top')
      })
    },
  	st(){
  		this.st1();
  		this.st2();
  	},
  	st1(){
			this.$http({
				url: "",
			}).then(res => {
				if(res.data.statusCode == 200){
					var data = res.data.getDeadAndPassData1;
					var dateList = [],
							data1 = [],
							data2 = [],
							data3 = [],
							data4 = [],
							data5 = [],
							data6 = [];
					data.forEach(item => {
						dateList.push(item.date);
						data1.push(item.deadCount);
						data2.push(item.deadRate);
						data3.push(item.passCount);
						data4.push(item.passRate);
						data5.push(item.deadAndPassCount);
						data6.push(item.deadAndPassRate);
					})
	  			
  				var myChart1 = echarts.init(document.getElementById('st1'),'dark');
       		var option1 = {
       				title: {
	       				text: '母猪死亡率',
	       				left: 'center',
	       				bottom: 5,
	       				textStyle: {
	       					fontSize: 14,
	       					fontWeight: 'bold'
	       				}
	       			},
					    tooltip: {
					      trigger: 'axis'
					    },
					    legend: {
				        data: ['死亡(头)', '死亡(率)'],
				        x : 'center'
					    },
					    xAxis: {
				        type: 'category',
				        data: dateList,
				        axisLabel: {  
								  interval:0,    
								}
						  },
					    yAxis: [
				        {
			            type: 'value',
			            name: '死亡(头)',
			            min: 0,
			            splitLine: false,
			            axisLabel: {
			              formatter: '{value}头'
			            }
				        },
				        {
			            type: 'value',
			            name: '死亡(率)',
			            min: 0,
			            max: 100,
			            axisLabel: {
			              formatter: '{value}%'
			            }
				        }
					    ],
					    series: [
			    			{
			            name: '死亡(头)',
			            type: 'bar',
			            data: data1,
			            barMaxWidth: 30
				        },
				        {
			            name: '死亡(率)',
			            type: 'line',
			            yAxisIndex: 1,
			            data: data2
				        }
						  ]
					};
					myChart1.setOption(option1);
					
					var myChart2 = echarts.init(document.getElementById('st2'),'dark');
       		var option2 = {
       				title: {
	       				text: '母猪淘汰率',
	       				left: 'center',
	       				bottom: 5,
	       				textStyle: {
	       					fontSize: 14,
	       					fontWeight: 'bold'
	       				}
	       			},
					    tooltip: {
					      trigger: 'axis'
					    },
					    legend: {
				        data: ['淘汰(头)', '淘汰(率)'],
				        x : 'center'
					    },
					    xAxis: {
				        type: 'category',
				        data: dateList,
				        axisLabel: {  
								  interval:0,    
								}
						  },
					    yAxis: [
				        {
			            type: 'value',
			            name: '淘汰(头)',
			            min: 0,
			            splitLine: false,
			            axisLabel: {
			              formatter: '{value}头'
			            }
				        },
				        {
			            type: 'value',
			            name: '淘汰(率)',
			            min: 0,
			            max: 100,
			            axisLabel: {
			              formatter: '{value}%'
			            }
				        }
					    ],
					    series: [
			    			{
			            name: '淘汰(头)',
			            type: 'bar',
			            data: data3,
			            barMaxWidth: 30
				        },
				        {
			            name: '淘汰(率)',
			            type: 'line',
			            yAxisIndex: 1,
			            data: data4
				        }
						  ]
					};
					myChart2.setOption(option2);
					
					var myChart3 = echarts.init(document.getElementById('st3'),'dark');
       		var option3 = {
       				title: {
	       				text: '母猪死淘率',
	       				left: 'center',
	       				bottom: 5,
	       				textStyle: {
	       					fontSize: 14,
	       					fontWeight: 'bold'
	       				}
	       			},
					    tooltip: {
					      trigger: 'axis'
					    },
					    legend: {
					      data: ['死淘(头)', '死淘(率)'],
					      x : 'center'
					    },
					    xAxis: {
				        type: 'category',
				        data: dateList,
				        axisLabel: {  
								  interval:0,    
								}
						  },
					    yAxis: [
				        {
			            type: 'value',
			            name: '死淘(头)',
			            min: 0,
			            splitLine: false,
			            axisLabel: {
			              formatter: '{value}头'
			            }
				        },
				        {
			            type: 'value',
			            name: '死淘(率)',
			            min: 0,
			            max: 100,
			            axisLabel: {
			              formatter: '{value}%'
			            }
				        }
					    ],
					    series: [
					    			{
					            name: '死淘(头)',
					            type: 'bar',
					            data: data5,
					            barMaxWidth: 30
						        },
						        {
					            name: '死淘(率)',
					            type: 'line',
					            yAxisIndex: 1,
					            data: data6
						        }
						  ]
					};
					myChart3.setOption(option3);
				}
			})
  	},
  	st2(){
  		this.$http({
  			url: "",
  		}).then(res => {
  			if(res.data.statusCode == 200){
  				var data = res.data.getChildOrgIds;
  				this.pigFarmList = data;
					this.pigFarm = data[0];
					if(this.type == "ST"){
		  			this.st3();
		  		}else if(this.type == "PZ"){
		  			this.pz3();
		  		}
  			}
  		})
  	},
  	getOtherFarm(item){
  		if(item.id == this.pigFarm.id) return;
  		this.pigFarm = item;
  		if(this.type == "ST"){
  			this.st3();
  		}else if(this.type == "PZ"){
  			this.pz3();
  			this.pz5();
  		}
  	},
  	st3(){
  		this.$http({
  			url: "",
  		}).then(res => {
  			if(res.data.statusCode == 200){
  				var data = res.data.getKanbanData;
  				var data1 = data[0];
  				var data2 = data[1];
  				var data1X = [];
  				var data2X = [];
  				var totalData1 = 0;
  				var dataBarData1 = [];
  				var dataLineData1 = [];
  				var totalData2 = 0;
  				var dataBarData2 = [];
  				var dataLineData2 = [];
  				for(var i in data1[0]){
  					if(i == 'date' || i == 'time'){
  						
  					}else{
  						data1X.push(i);
  						data1.forEach(item => {
  							totalData1 += item[i];
  						})
  					}
  				}
  				for(var i in data2[0]){
  					if(i == 'date' || i == 'time'){
  						
  					}else{
  						data2X.push(i);
  						data2.forEach(item => {
  							totalData2 += item[i];
  						})
  					}
  				}
  				
  				
  				data1X.forEach(name => {
  					var totalData = 0;
  					data1.forEach(item => {
	  					totalData += item[name];
	  				})
  					dataBarData1.push(totalData);
  					dataLineData1.push((totalData/totalData1).toFixed(2)*100);
  				})
  				data2X.forEach(name => {
  					var totalData = 0;
  					data2.forEach(item => {
	  					totalData += item[name];
	  				})
  					dataBarData2.push(totalData);
  					dataLineData2.push((totalData/totalData2).toFixed(2)*100);
  				})
  				
  				var myChart1 = echarts.init(document.getElementById('st4'),'dark');
       		var option1 = {
       				title: {
	       				text: '母猪死亡原因',
	       				left: 'center',
	       				bottom: 5,
	       				textStyle: {
	       					fontSize: 14,
	       					fontWeight: 'bold'
	       				}
					   },
					    tooltip: {
					      trigger: 'axis'
					    },
					    xAxis: {
				        type: 'category',
				        data: data1X,
				        axisLabel: {  
								  interval:0,    
								  rotate: 40
								}
						  },
					    yAxis: [
					        {
				            type: 'value',
				            name: '头',
				            min: 0,
				            splitLine: false,
				            axisLabel: {
				              formatter: '{value}头'
				            }
					        },
					        {
				            type: 'value',
				            name: '比例',
				            min: 0,
				            max: 100,
				            axisLabel: {
				              formatter: '{value}%'
				            }
					        }
					    ],
					    series: [
					    			{
					            type: 'bar',
					            data: dataBarData1,
					            barMaxWidth: 30
						        },
						        {
					            type: 'line',
					            yAxisIndex: 1,
					            data: dataLineData1
						        }
						  ]
					};
					myChart1.setOption(option1);
					var myChart2 = echarts.init(document.getElementById('st5'),'dark');
       		var option2 = {
       				title: {
	       				text: '母猪淘汰原因',
	       				left: 'center',
	       				bottom: 5,
	       				textStyle: {
	       					fontSize: 14,
	       					fontWeight: 'bold'
	       				}
	       			},
					    tooltip: {
					      trigger: 'axis'
					    },
					    xAxis: {
				        type: 'category',
				        data: data2X,
				        axisLabel: {  
								  interval:0,    
								  rotate: 40
								}  
						  },
					    yAxis: [
					        {
				            type: 'value',
				            name: '头',
				            min: 0,
				            splitLine: false,
				            axisLabel: {
				              formatter: '{value}头'
				            }
					        },
					        {
				            type: 'value',
				            name: '比例',
				            min: 0,
				            max: 100,
				            axisLabel: {
				              formatter: '{value}%'
				            }
					        }
					    ],
					    series: [
				    			{
				            type: 'bar',
				            data: dataBarData2,
				            barMaxWidth: 30
					        },
					        {
				            type: 'line',
				            yAxisIndex: 1,
				            data: dataLineData2
					        }
						  ]
					};
					myChart2.setOption(option2);
  			}
  		})
  	},
  	pz(){
  		this.pz1();
  		this.pz2();
  		this.st2();
//		this.pz4();
  		this.pz5();
  	},
  	pz1(){
  		this.$http({
  			url: ""
  		}).then(res => {
  			if(res.data.statusCode == 200){
  				var data = res.data.listProductionDefaultDetailChartData;
  				var myChart1 = echarts.init(document.getElementById('pz1'),'dark');
  				var legendData = ['配种头数','受胎头数','目标受胎率','实际受胎数'];
  				var timeData = data.data.dateTimes.split(",");
  				var data1 = data.data,
							p_standard_values = data1.p_standard_values.split(","),
							p_values = data1.p_values.split(","),
							mating_numbers = data1.mating_numbers.split(","),
							actual_mating_numbers = data1.actual_mating_numbers.split(",");
  				var option1 = {
			        title: {
				        text: data.typeName
					    },
					    tooltip: {
					      trigger: 'axis'
					    },
					    legend: {
				        data: legendData,
				        x: 'center'
					    },
					    xAxis: [
				        {
			            type: 'category',
			            axisTick: {
			                alignWithLabel: true
			            },
			            axisLabel: {  
									  interval:0,    
									},
			            data: timeData
				        }
					    ],
					    yAxis: [
				        {
			            type: 'value',
			            name: '胎数',
			            min: 0,
			            axisLabel: {
			              formatter: '{value}'
			            },
			            splitLine: {
			            	show: false
			            }
				        },
				        {
			            type: 'value',
			            min: 0,
			            max: 100,
			            position: 'right',
			            interval: 10,
			            axisLabel: {
			              formatter: '{value} %'
			            },
			            splitLine: {
			            	show: false
			            }
				        }
					    ],
					    series: [
				    		{
			            name:'配种头数',
			            type:'bar',
			            data: mating_numbers
				        },
				        {
			            name:'受胎头数',
			            type:'bar',
			            data: actual_mating_numbers
				        },
				        {
			            name:'目标受胎率', 
			            type:'line',
			            yAxisIndex: 1,
			            data: p_standard_values
				        },
				        {
			            name:'实际受胎数',
			            type:'line',
			            yAxisIndex: 1,
			            data: p_values,
			            markLine: {
				            silent: true,
										label: {
											show: false,
										},
		                data: [{
		                    yAxis: p_standard_values[0]
		                }]
				          }
				        }
					    ],
					    visualMap: [
					    	{
					    		top: 10,
					        right: 10,
									textStyle:{
			              color:'#F8F8FF'
			            },
			            pieces: [{
		                gt: 0,
		                lte: data1.p_standard_values.split(",")[0] - 8,
		                color: 'red'
			            }, {
		                gt: data1.p_standard_values.split(",")[0] - 8,
		                color: 'green'
			            }],
			            seriesIndex: 3 
					    	}
					  	]
				    };
					myChart1.setOption(option1);
  			}
  		})
  	},
  	pz2(){
  		this.$http({
        url: "",
      }).then(res => { 
       	if(res.status == 200){
       		var data = res.data.kanBanGetEchartsJsonData;
       		var myChart = echarts.init(document.getElementById('pz3'),'dark');
       		var option = {
						    tooltip : {
					        trigger: 'item',
					        formatter: "{b} : {c} ({d}%)"
						    },
						    legend: {
					        orient: 'vertical',
					        left: 'left',
					        data: ['怀孕头数','流产头数','返情头数','空怀头数(1-30天)','空怀头数(30天以上)']
						    },
						    series: [
						        {
					            type: 'pie',
					            radius : '55%',
					            center: ['50%', '50%'],
					            data:[
				                {value: data.pregnantNumber, name: '怀孕头数'},
				                {value: data.abortionSize, name: '流产头数'},
				                {value: data.antiloveNumber, name: '返情头数'},
				                {value: data.nonpregnancySize, name: '空怀头数(1-30天)'},
				                {value: data.MoreThanOneMonthNonpregnancySize, name: '空怀头数(30天以上)'}
					            ],
					            labelLine: {
					            	length: 5
					            },
					            itemStyle: {
				                emphasis: {
			                    shadowBlur: 10,
			                    shadowOffsetX: 0,
			                    shadowColor: 'rgba(0, 0, 0, 0.5)'
				                }
					            }
						        }
						    ]
						};
						myChart.setOption(option);
       	}
      }).catch(err => { 

      })
  	},
  	pz3(){
  		this.$http({
  			url: ""
  		}).then(res => {
			if(res.status == 200){
				var data = res.data.getkanbanquery;
				
				var myChart1 = echarts.init(document.getElementById('pz2'),'dark');
	   		var option1 = {
	       			title: {
	       				text: '断奶至返情分析',
	       				align: 'left',
	       				textStyle: {
	       					fontSize: '14px'
	       				}
	       			},
			        tooltip : {
			          trigger: 'axis'
			        },
			        grid: {
		            top: '30px',
		            left: '50px',
		            right: '0px',
		            bottom: '20px'
			        },
			        xAxis: { 
	            type: 'category',
	            data: ["7","8-17","18-19","20-23","24-25","26-30","31-35","36-50","51-60","61-70","71-80","81-90","91-100","100以上"],
	            axisLabel: {
	            	interval: 0
	            },
	            splitLine: {
	            	show: false
	            }
			        },
			        yAxis: {
			          type: 'value'
			        },
			        series: [
		            {
	                name: '数量',
	                type: 'bar',
	                data: data
		            }
			        ]
			    };
					myChart1.setOption(option1);
				}
  		})
  	},
  	// 最佳射手
  	pz4(){
  		this.$http({
  			url: "/homePage/statisticsReport/breedingSow/oldReport/tuppingDeliveryRate/kanBanTuppingBoar.act",
  			method: "post",
  			params: {
  				minDate: moment().subtract(6, "months").format("YYYY-MM-DD"),
  				maxDate: moment().subtract(1, "months").format("YYYY-MM-DD")
  			}
  		}).then(res => {
			if(res.status == 200){
				var data = res.data;
				var legendData = [];
				var seriesData = [];
				data.forEach(item => {
					legendData.push(item.earIdentify);
					seriesData.push(item.tuppingRate);
				})
				var myChart1 = echarts.init(document.getElementById('pz4'),'dark');
	   		var option1 = {
	       			title: {
	       				text: '断奶至返情分析',
	       				align: 'left',
	       				textStyle: {
	       					fontSize: '14px'
	       				}
	       			},
			        tooltip: {
					        trigger: 'axis',
					        axisPointer: {
					            type: 'shadow'
					        }
					    },
					    legend: {
					        data: ['最佳射手']
					    },
					    grid: {
					        left: '3%',
					        right: '4%',
					        bottom: '3%',
					        top: 25,
					        containLabel: true
					    },
					    xAxis: {
					        type: 'value'
					    },
					    yAxis: {
					        type: 'category',
					        data: legendData,
					        axisLabel: {  
									  interval: 0,    
									},
					    },
					    series:
					        {
					            name: '最佳射手',
					            type: 'bar',
					            data: seriesData
					        }
			    };
					myChart1.setOption(option1);
				}
  		})
  	},
  	// 配种能手
  	pz5(){
  		this.$http({
  			url: "",
  			params: {
  				minDate: moment().subtract(6, "months").format("YYYY-MM-DD"),
  				maxDate: moment().subtract(1, "months").format("YYYY-MM-DD")
  			}
  		}).then(res => {
			if(res.status == 200){
				var data = res.data.kanBanTuppingPerson;
				var legendData = [];
				var seriesData = [];
				data.forEach(item => {
					legendData.push(item.tuppingPerson);
					seriesData.push(item.tuppingRate);
				})
				var myChart1 = echarts.init(document.getElementById('pz5'),'dark');
	   		var option1 = {
	       			title: {
	       				text: '断奶至返情分析',
	       				align: 'left',
	       				textStyle: {
	       					fontSize: '14px'
	       				}
	       			},
			        tooltip: {
					        trigger: 'axis',
					        axisPointer: {
					            type: 'shadow'
					        }
					    },
					    legend: {
					        data: ['最佳配种能手']
					    },
					    grid: {
					        left: '3%',
					        right: '4%',
					        bottom: '3%',
					        top: 25,
					        containLabel: true
					    },
					    xAxis: {
					        type: 'value'
					    },
					    yAxis: {
					        type: 'category',
					        data: legendData,
					        axisLabel: {  
									  interval: 0,    
									},
					    },
					    series:
					        {
					            name: '最佳配种能手',
					            type: 'bar',
					            data: seriesData
					        }
			    };
					myChart1.setOption(option1);
				}
  		})
  	},
  	fm(){
  		this.fm1();
  		this.fm2();
  		this.fm3();
  		this.fm4();
  	},
  	// 配种分娩
  	fm1(){
  		this.$http({
        url: ""
      }).then(res => { 
       	if(res.data.statusCode == 200){
       		var data = res.data.getTuppingFarrowingRateChartData;
       		
       		var myChart1 = echarts.init(document.getElementById('fm1'),'dark');
       		var option1 = {
			        tooltip : {
			          trigger: 'axis'
			        },
			        legend: {
			          data:['配种头数', '受胎头数', '产仔头数']
			        },
			        grid: {
		            top: '30px',
		            left: '50px',
		            right: '0%',
		            bottom: '20px'
			        },
			        xAxis: {
                type: 'category',
                data: data.dateRange
			        },
			        yAxis: {
			          type : 'value'
			        },
			        series : [
			            {
		                name: '配种头数',
		                type: 'bar',
		                data: data.tuppingCount
			            },
			            {
		                name: '受胎头数',
		                type: 'bar',
		                data: data.pregnancyCount
			            },
			            {
		                name: '产仔头数',
		                type: 'bar',
		                data: data.sowCount
			            }
			        ]
			    };
					myChart1.setOption(option1);
					
					var myChart2 = echarts.init(document.getElementById('fm2'),'dark');
					var option2 = {
				    tooltip: {
				      trigger: 'axis',
				    },
				    legend: {
				      data: ['目标配种分娩率','实际配种分娩率']
				    },
				    grid: {
				    	top: '30px',
			        left: '50px',
			        right: '0%',
			        bottom: '20px'
				    },
				    xAxis: {
			        type: 'category',
			        data: data.dateRange
				    },
				    yAxis: {
				      type: 'value'
				    },
				    series: [
			        {
		            name: '目标配种分娩率',
		            type: 'line',
		            data: data.planTuppingDeliveryRate
			        },
			        {
		            name: '实际配种分娩率',
		            type: 'line',
		            data: data.tuppingDeliveryRate
			        }]
					};
					myChart2.setOption(option2);
       	}
      }).catch(err => { 
      	
      })
  	},
  	fm2(){
  		this.$http({
        url: ""
      }).then(res => { 
       	if(res.data.statusCode == 200){
       		var data = res.data.getFarrowingStatisticsChartData;
       		var myChart = echarts.init(document.getElementById('fm5'),'dark');
       		var option = {
						    tooltip : {
					        trigger: 'item',
					        formatter: "{b} : {c} ({d}%)"
						    },
						    legend: {
					        orient: 'vertical',
					        left: 'left',
					        data: ['产活仔数','畸形数','死胎数','木乃伊数']
						    },
						    series: [
						        {
					            type: 'pie',
					            radius : '55%',
					            center: ['50%', '50%'],
					            data:[
				                {value: data.liveCount, name: '产活仔数'},
				                {value: data.deformityCount, name: '畸形数'},
				                {value: data.deadCount, name: '死胎数'},
				                {value: data.mummyCount, name: '木乃伊数'}
					            ],
					            labelLine: {
					            	length: 5
					            },
					            itemStyle: {
				                emphasis: {
			                    shadowBlur: 10,
			                    shadowOffsetX: 0,
			                    shadowColor: 'rgba(0, 0, 0, 0.5)'
				                }
					            }
						        }
						    ]
						};
						myChart.setOption(option);
       	}
      }).catch(err => { 

      })
  	},
  	fm3(){
  		this.$http({
  			url: ""
  		}).then(res => {
  			if(res.data.statusCode == 200){
  				var data = res.data.getNursingSowLivabilityChartData;
					var myChart2 = echarts.init(document.getElementById('fm7'),'dark');
       		var option2 = {
			        tooltip : {
			          trigger: 'axis'
			        },
			        legend: {
			          data:['产活仔数', '其中断奶活仔数']
			        },
			        grid: {
		            top: '30px',
		            left: '50px',
		            right: '0%',
		            bottom: '20px'
			        },
			        xAxis: {
                type: 'category',
                data: data.dateRange
			        },
			        yAxis: {
			          type : 'value'
			        },
			        series : [
			            {
		                name: '产活仔数',
		                type: 'bar',
		                data: data.liveSum
			            },
			            {
		                name: '其中断奶活仔数',
		                type: 'bar',
		                data: data.weaningSum
			            }
			        ]
			    };
					myChart2.setOption(option2);
					
					var myChart3 = echarts.init(document.getElementById('fm8'),'dark');
					var option3 = {
					    tooltip: {
					      trigger: 'axis',
					    },
					    legend: {
					      data: ['成活率','目标成活率']
					    },
					    grid: {
					    	top: '30px',
				        left: '50px',
				        right: '0%',
				        bottom: '20px'
					    },
					    xAxis: {
				        type: 'category',
				        data: data.dateRange
					    },
					    yAxis: {
					      type: 'value'
					    },
					    series: [
				        {
			            name: '成活率',
			            type: 'line',
			            data: data.liveRate
				        },
				        {
			            name: '目标成活率',
			            type: 'line',
			            data: data.planLiveRate
				        }]
						};
						myChart3.setOption(option3);
  			}
  		})
  	},
  	fm4(){
  		this.$http({
        url: ""
     }).then(res => { 
       	if(res.data.statusCode == 200){
       		var data = res.data.getTuppingFarrowingChartDataByYeild;
       		
       		var myChart1 = echarts.init(document.getElementById('fm3'),'dark');
       		var option1 = {
			        tooltip : {
			          trigger: 'axis'
			        },
			        legend: {
			          data:['配种头数', '受胎头数', '产仔头数']
			        },
			        grid: {
		            top: '30px',
		            left: '50px',
		            right: '0%',
		            bottom: '20px'
			        },
			        xAxis: {
                type: 'category',
                data: data.dateRange
			        },
			        yAxis: {
			          type : 'value'
			        },
			        series : [
			            {
		                name: '配种头数',
		                type: 'bar',
		                data: data.tuppingCount
			            },
			            {
		                name: '受胎头数',
		                type: 'bar',
		                data: data.pregnancyCount
			            },
			            {
		                name: '产仔头数',
		                type: 'bar',
		                data: data.sowCount
			            }
			        ]
			    };
					myChart1.setOption(option1);
					
					var myChart2 = echarts.init(document.getElementById('fm4'),'dark');
					var option2 = {
				    tooltip: {
				      trigger: 'axis',
				    },
				    legend: {
				      data: ['目标配种分娩率','实际配种分娩率']
				    },
				    grid: {
				    	top: '30px',
			        left: '50px',
			        right: '0%',
			        bottom: '20px'
				    },
				    xAxis: {
			        type: 'category',
			        data: data.dateRange
				    },
				    yAxis: {
				      type: 'value'
				    },
				    series: [
			        {
		            name: '目标配种分娩率',
		            type: 'line',
		            data: data.planTuppingDeliveryRate
			        },
			        {
		            name: '实际配种分娩率',
		            type: 'line',
		            data: data.tuppingDeliveryRate
			        }]
					};
					myChart2.setOption(option2);
       	}
      }).catch(err => { 
      	
      })
  	},
  	dn(){
  		this.dn1();
  		this.dn2();
  		this.dn3();
  		this.dn4();
  	},
  	dn1(){
  		this.$http({
  			url: ""
  		}).then(res => {
  			if(res.data.statusCode == 200){
  				var data = res.data.getWeaningEstrusRateCharData;
  				
  				var myChart1 = echarts.init(document.getElementById('dn1'),'dark');
       		var option1 = {
			        tooltip : {
			          trigger: 'axis'
			        },
			        legend: {
			          data:['断奶头数', '七天内配种头数']
			        },
			        grid: {
		            top: '30px',
		            left: '50px',
		            right: '0px',
		            bottom: '20px'
			        },
			        xAxis: {
                type: 'category',
                data: data.dateRange,
                axisLabel: {
                	interval: 0
                },
			        },
			        yAxis: {
			          type : 'value'
			        },
			        series : [
			            {
		                name: '断奶头数',
		                type: 'bar',
		                data: data.weaningCount
			            },
			            {
		                name: '七天内配种头数',
		                type: 'bar',
		                data: data.in7Day
			            }
			        ]
			    };
					myChart1.setOption(option1);
					
					var myChart2 = echarts.init(document.getElementById('dn2'),'dark');
					var option2 = {
				    tooltip: {
				      trigger: 'axis',
				    },
				    legend: {
				      data: ['七天断奶发情率','目标七天断奶发情率']
				    },
				    grid: {
				    	top: '30px',
			        left: '50px',
			        right: '0px',
			        bottom: '20px'
				    },
				    xAxis: {
			        type: 'category',
			        data: data.dateRange,
			        axisLabel: {
	            	interval: 0
	            },
				    },
				    yAxis: {
				      type: 'value'
				    },
				    series: [
			        {
		            name: '七天断奶发情率',
		            type: 'line',
		            data: data.weaningRate
			        },
			        {
		            name: '目标七天断奶发情率',
		            type: 'line',
		            data: data.planWeaningRate
			        }]
					};
					myChart2.setOption(option2);
					
//					var myChart3 = echarts.init(document.getElementById('dn3'),'dark');
//     		var option3 = {
//			        tooltip : {
//			          trigger: 'axis'
//			        },
//			        legend: {
//			          data:['断奶头数', '七天内配种头数']
//			        },
//			        grid: {
//		            top: '30px',
//		            left: '50px',
//		            right: '30px',
//		            bottom: '20px'
//			        },
//			        xAxis: {
//              type: 'category',
//              data: data.dateRange
//			        },
//			        yAxis: {
//			          type : 'value'
//			        },
//			        series : [
//			            {
//		                name: '断奶头数',
//		                type: 'bar',
//		                data: data.weaningCount
//			            },
//			            {
//		                name: '七天内配种头数',
//		                type: 'bar',
//		                data: data.in7Day
//			            }
//			        ]
//			    };
//					myChart3.setOption(option3);
  			}
  		})
  	},
  	dn2(){
  		this.$http({
  			url: ""
  		}).then(res => {
  			if(res.data.statusCode == 200){
  				var data = res.data.getChildLiveRateChartData;
  				
  				var myChart1 = echarts.init(document.getElementById('dn4'),'dark');
       		var option1 = {
			        tooltip : {
			          trigger: 'axis'
			        },
			        legend: {
			          data:['期初存栏', '新增入场','死亡数量']
			        },
			        grid: {
		            top: '30px',
		            left: '50px',
		            right: '0px',
		            bottom: '20px'
			        },
			        xAxis: {
                type: 'category',
                data: data.dateRange,
                axisLabel: {
                	interval: 0
                },
			        },
			        yAxis: {
			          type : 'value'
			        },
			        series : [
			            {
		                name: '期初存栏',
		                type: 'bar',
		                data: data.firstCount
			            },
			            {
		                name: '新增入场',
		                type: 'bar',
		                data: data.entranceCount
			            },
			            {
		                name: '死亡数量',
		                type: 'bar',
		                data: data.dieCount
			            }
			        ]
			    };
					myChart1.setOption(option1);
					
					var myChart2 = echarts.init(document.getElementById('dn5'),'dark');
					var option2 = {
				    tooltip: {
				      trigger: 'axis',
				    },
				    legend: {
				      data: ['存活率','目标存活率']
				    },
				    grid: {
				    	top: '30px',
			        left: '50px',
			        right: '0px',
			        bottom: '20px'
				    },
				    xAxis: {
			        type: 'category',
			        data: data.dateRange,
			        axisLabel: {
	            	interval: 0
	            },
				    },
				    yAxis: {
				      type: 'value'
				    },
				    series: [
			        {
		            name: '存活率',
		            type: 'line',
		            data: data.rate
			        },
			        {
		            name: '目标存活率',
		            type: 'line',
		            data: data.planRate
			        }]
					};
					myChart2.setOption(option2);
				}	
			})
  	},
  	dn3(){
  		this.$http({
  			url: ""
  		}).then(res => {
  			if(res.data.statusCode == 200){
  				var data = res.data.getWeaningToTuppingChartData;
  				
  				var myChart1 = echarts.init(document.getElementById('dn3'),'dark');
       		var option1 = {
	       			title: {
	       				text: '配种至返情分布',
	       				align: 'left',
	       				textStyle: {
	       					fontSize: '14px'
	       				}
	       			},
			        tooltip : {
			          trigger: 'axis'
			        },
			        grid: {
		            top: '30px',
		            left: '50px',
		            right: '35px',
		            bottom: '20px'
			        },
			        xAxis: { 
                type: 'category',
                data: data.dateRange,
                axisLabel: {
                	interval: 0
                },
                name: "(天)", 
                splitLine: {
                	show: false
                }
			        },
			        yAxis: {
			          type : 'value'
			        },
			        series : [
		            {
	                name: '数量',
	                type: 'bar',
	                data: data.pigCount
		            }
			        ]
			    };
					myChart1.setOption(option1);
				}
  		})
  	},
  	dn4(){
  		this.$http({
  			url: ""
  		}).then(res => {
  			if(res.data.statusCode == 200){
  				var data = res.data.getTuppingToBackLoveDistributionChartData;
  				
  				var myChart1 = echarts.init(document.getElementById('dn6'),'dark');
       		var option1 = {
	       			title: {
	       				text: '配种至返情分析',
	       				align: 'left',
	       				textStyle: {
	       					fontSize: '14px'
	       				}
	       			},
			        tooltip : {
			          trigger: 'axis'
			        },
			        grid: {
		            top: '30px',
		            left: '50px',
		            right: '35px',
		            bottom: '20px'
			        },
			        xAxis: { 
                type: 'category',
                data: data.dateRange,
                axisLabel: {
                	interval: 0
                },
                name: "(天)", 
                splitLine: {
                	show: false
                }
			        },
			        yAxis: {
			          type : 'value'
			        },
			        series : [
		            {
	                name: '数量',
	                type: 'bar',
	                data: data.dataList
		            }
			        ]
			    };
					myChart1.setOption(option1);
				}
  		})
  	},
  	cl(){
  		this.cl1(); 
  		this.cl2();
  	},
  	cl1(){
  		this.$http({
  			url: "" 
  		}).then(res => {
  			if(res.data.statusCode == 200){
				  var data = res.data.survivalRateAnalysis;
  				var myChart1 = echarts.init(document.getElementById('cl1'),'dark');
			    // 指定图表的配置项和数据
			    var option1 = { 
						    title: {
						      text: '出栏分析'
						    },
						    tooltip: {
						      trigger: 'axis'
						    },
						    grid: {
					        left: '3%',
					        right: '5%',
					        bottom: '7%',
					        containLabel: true  
						    },
						    legend: {
						      data:['计划保育猪出栏','实际保育猪出栏','计划肥猪出栏','实际肥猪出栏']
						    },
						    xAxis: [
					        {
				            type: 'category',
				            data: data.date.createType.split(","),
				            axisPointer: {
				              type: 'shadow'
				            }
					        }
						    ],
						    yAxis: [
					        {
				            type: 'value',
				            name: '头数',
				            min: 0,
				            splitLine: false,
				            axisLabel: {
				              formatter: '{value}'
				            }
					        }
						    ],
						    series: [
						        {
					            name:'计划保育猪出栏',
					            barGap: 1,
					            type:'bar',
					            data: data.clbyzz.standardValue.split(",")
						        },
						        {
					            name:'实际保育猪出栏',
					            barGap: 1,
					            type:'bar',
					            data: data.clbyzz.value.split(",")
						        },
						        {
					            name:'计划肥猪出栏',
					            barGap: 2,
					            type:'bar',
					            data: data.clhz.standardValue.split(",")
						        },
						        {
					            name:'实际肥猪出栏',
					            barGap: 2,
					            type:'bar',
					           	data: data.clhz.value.split(",")
						        }
						    ]
						};   
						myChart1.setOption(option1);
  			}
  		})
  	},
  	cl2(){
  		this.$http({
  			url: ""
  		}).then(res => {
  			if(res.data.statusCode == 200){
  				var data = res.data.listCapacityDefaultDetailChartData;
  				var myChart1 = echarts.init(document.getElementById('cl2'),'dark'),
							timeData = [],
							seriesData = [];
							data.data.forEach(item => {
								timeData.push(item.p_create_type);
								seriesData.push(item.p_value);
							})
			        // 指定图表的配置项和数据
			        var option1 = {
				        title: {
				          text: data.typeName + '(%)'
				        },
				        tooltip: {
				          trigger: 'axis'
				        },
				        grid: {
					        left: '3%',
					        right: '5%',
					        bottom: '7%',
					        containLabel: true  
						    },
				        xAxis: {
				          data: timeData
				        },
				        yAxis: {
			            splitLine: {
			              show: false
			            },
			            min:0,
			            max: 100,
				        },
				        dataZoom: [{
				          type: 'inside'
				        }],
				        visualMap: {
			            top: 10,
			            right: 10,
									textStyle:{
			              color:'#F8F8FF'
			            },
			            pieces: [{
		                gt: 0,
		                lte: data.data[0].p_standard_value,
		                color: '#FF0000'
			            }, {
		                gt: data.data[0].p_standard_value,
		                color: '#228B22'
			            }] 
				        },
				        series: {
			            name: data.typeName,
			            type: 'line',
			            data: seriesData,
			            markLine: {
		                silent: true,
										color:'#F8F8FF',
		                data: [{
		                  yAxis: data.data[0].p_standard_value
		                }]
			            }
				        }
					    };
						myChart1.setOption(option1);
  			}
  		})
  	}
 	},
 	mounted(){ 
   		this.init();
   		this.init1();
   		myVue.on("changeOrg",(data) => {
   			this.init();
   			this.init1();
   		})
		this.changeName("生产专项看板");
	}
} 
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src="../css/special.scss" lang="scss"></style>



// WEBPACK FOOTER //
// src/components/special.vue